import { gql } from 'apollo-angular';

const RENAME_RFP_CATEGORY = gql`
  mutation RenameRfpCategory($id: Long!, $name: String!) {
    renameRfpCategory(renameRfpCategoryRequest: { id: $id, name: $name }) {
      id
    }
  }
`;

export default RENAME_RFP_CATEGORY;
